export default __webpack_public_path__ + "static/media/gallery_04.642b37a6.jpg";